import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c(VContainer,[_c(VRow,{staticClass:"pt-2"},[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('ContactForm')],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('ContactDetails')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }